module.exports = __webpack_public_path__ + "img/canarywarf.b41ad768.png";